module.exports = __webpack_public_path__ + "static/media/server.12c7d746.svg";